import React from "react";
import { RouterProvider } from "react-router-dom";
import ErrorProvider from "./contexts/error";
import TimeProvider from "./contexts/time";
import UiProvider from "./contexts/ui";
import IntlProvider from "./locales/IntlProvider";
import router from "./routes/index";

const Root: React.FC = () => (
  <React.StrictMode>
    <ErrorProvider>
      <UiProvider>
        <IntlProvider>
          <TimeProvider>
            <RouterProvider router={router} />
          </TimeProvider>
        </IntlProvider>
      </UiProvider>
    </ErrorProvider>
  </React.StrictMode>
);

export default Root;
